/** Dependencies */
import BaseService from './BaseService';
import { voltranGatewayApiUrl } from '../appConfig';

const VoltranGwService = () => {
  const validateTwoFactorSmsOtp = params => {
    return BaseService.post(
      `${voltranGatewayApiUrl}/api/TwoFactor/ValidateTwoFactorSmsOtp`,
      params
    );
  };

  const validateTwoFactorEmailOtp = params => {
    return BaseService.post(
      `${voltranGatewayApiUrl}/api/TwoFactor/ValidateTwoFactorEmailOtp`,
      params
    );
  };

  const getCities = () => {
    return BaseService.get(`${voltranGatewayApiUrl}/api/shipping/cities/TUR`);
  };

  const getTowns = code => {
    return BaseService.get(`${voltranGatewayApiUrl}/api/shipping/towns/${code}`);
  };

  const getDistricts = code => {
    return BaseService.get(`${voltranGatewayApiUrl}/api/shipping/districts/${code}`);
  };

  const addressSuggestion = (searchWord, coords) => {
    return BaseService.get(
      `${voltranGatewayApiUrl}/api/shipping/address-suggestion?search=${searchWord}${
        coords && coords.latitude && coords.longitude
          ? `&lat=${coords.latitude}&lon=${coords.longitude}`
          : ''
      }`
    );
  };

  const validateAutoSuggestion = (city, town, district) => {
    return BaseService.get(
      `${voltranGatewayApiUrl}/api/shipping/validate/auto-suggestion?city=${city}&town=${town}&district=${district}`
    );
  };

  const getAddress = addressId => {
    return BaseService.get(`${voltranGatewayApiUrl}/api/users/addresses/${addressId}`);
  };

  const deleteAddress = addressData => {
    return BaseService.delete(`${voltranGatewayApiUrl}/api/users/addresses/${addressData}`);
  };

  const updateAddress = addressData => {
    return BaseService.put(`${voltranGatewayApiUrl}/api/users/addresses`, addressData);
  };

  const getAddresses = () => {
    return BaseService.get(`${voltranGatewayApiUrl}/api/users-addresses/types/1`);
  };

  const createAddresses = addressData => {
    return BaseService.post(`${voltranGatewayApiUrl}/api/users/addresses`, addressData);
  };

  const getUserPermissions = () => {
    return BaseService.get(`${voltranGatewayApiUrl}api/users/notificationpermissions/1`);
  };

  const createLazyToCustomerRegisterRequest = params => {
    return BaseService.post(
      `${voltranGatewayApiUrl}/api/customer/createlazytocustomerregisterrequest`,
      params
    );
  };

  const updatePrimaryNotificationPermissions = (source = 'CustomerMarketing') => {
    return BaseService.put(`${voltranGatewayApiUrl}/api/users/notificationpermissions/primary`, {
      Permission: true,
      Source: source
    });
  };

  const getSubscriptionInfo = () => {
    return BaseService.get(`${voltranGatewayApiUrl}/api/loyalty/subscription-info`);
  };

  const tcknVerification = params => {
    return BaseService.post(`${voltranGatewayApiUrl}/api/customers/tckn`, params);
  };

  const verifyTckn = params => {
    return BaseService.post(
      `${voltranGatewayApiUrl}/api/customers/national-identity/validation`,
      params
    );
  };

  const vasEvaluate = params => {
    return BaseService.post(`${voltranGatewayApiUrl}/api/vas/evaluate`, params);
  };

  const vasDetails = sku => {
    return BaseService.get(
      `${voltranGatewayApiUrl}/api/vas/details?filters[sku][$eq]=${sku}&populate=*`
    );
  };

  const getNavigationProducts = (params = {}) => {
    // Default query parameters
    const defaultParams = {
      filter: 'VariantList.VariantListing.TagList.TagId:aninda-indirimle-eskiyi-kapinda-yenile',
      page: 1,
      pageType: 'Tag',
      size: 10,
      sortType: 'yorumsayisi'
    };

    const queryParams = new URLSearchParams({ ...defaultParams, ...params }).toString();
    const url = `${voltranGatewayApiUrl}/navigation/product?${queryParams}`;
    return BaseService.get(url);
  };

  const validateJwt = () => {
    return BaseService.get(`${voltranGatewayApiUrl}/validate`);
  };

  return {
    validateTwoFactorSmsOtp: params => validateTwoFactorSmsOtp(params),
    validateTwoFactorEmailOtp: params => validateTwoFactorEmailOtp(params),
    getCities: () => getCities(),
    getTowns: code => getTowns(code),
    getDistricts: code => getDistricts(code),
    addressSuggestion: (searchWord, coords) => addressSuggestion(searchWord, coords),
    validateAutoSuggestion: (city, town, district) => validateAutoSuggestion(city, town, district),
    getAddress: addressId => getAddress(addressId),
    deleteAddress: addressId => deleteAddress(addressId),
    updateAddress: addressData => updateAddress(addressData),
    getAddresses: () => getAddresses(),
    createAddresses: addressData => createAddresses(addressData),
    getUserPermissions: () => getUserPermissions(),
    createLazyToCustomerRegisterRequest: params => createLazyToCustomerRegisterRequest(params),
    updatePrimaryNotificationPermissions: source => updatePrimaryNotificationPermissions(source),
    getSubscriptionInfo: () => getSubscriptionInfo(),
    tcknVerification: params => tcknVerification(params),
    verifyTckn: params => verifyTckn(params),
    vasEvaluate: params => vasEvaluate(params),
    vasDetails: sku => vasDetails(sku),
    getNavigationProducts: params => getNavigationProducts(params),
    validateJwt: () => validateJwt()
  };
};

export default VoltranGwService();
